import moment from 'moment';

export default class PeriodService {
    constructor() {
        /** @type {moment[]} */
        this.period = [];
    }

    /** 
     * @param {moment} start - Start date.
     * @param {moment} end - End date.
     * @returns {void}
     */
    setInterval(start, end) {
        this.reset();

        if(end < start) {
            [start, end] = [end, start]
        }

        const diff = (end.startOf('day')).diff(start.startOf('day'), 'd');
        const startDayCount = 1;

        this.setIntervalByDays(start, startDayCount + diff);
    }

    /**
     * @param {moment} start - Start date.
     * @param {number} days - Number of days.
     * @returns {void}
     */
    setIntervalByDays(start, days) {
        this.reset();

        if(days <= 1) {
            this.period = [moment(start.startOf('day'))];
            return;
        }

        for(let dt = moment(start.startOf('day')), i = 0; i < days; dt.add(1, 'd'), ++i) {
            this.period.push(moment(dt));
        }
    }

    reset() {
        this.period = [];
    }
}
